import { ImageUpload as AntdImageUpload } from "@empglabs/backoffice-ui-kit"

const ImageUpload = props => {
  return <AntdImageUpload {...props} />
}

export default ImageUpload
